import { SeeqNames } from '@/main/app.constants.seeqnames';
import { VantageNames } from '@/vantage/constants';

export const coreColumns = [
  [VantageNames.Columns.ConditionID, 'UUID', SeeqNames.MaterializedTables.ItemIdColumn],
  [VantageNames.Columns.Condition, 'text', VantageNames.Columns.Condition],
  [VantageNames.Columns.DatumID, 'text', SeeqNames.MaterializedTables.DatumIdColumn],
  [VantageNames.GridColumnNames.TimeCreated, 'datetime', VantageNames.Columns.CreatedAt],
  [VantageNames.GridColumnNames.TimeUpdated, 'datetime', VantageNames.Columns.UpdatedAt],
];

export const excludedColumns = [
  SeeqNames.MaterializedTables.ItemIdColumn,
  SeeqNames.MaterializedTables.DatumIdColumn,
  VantageNames.Columns.Kind,
  VantageNames.Columns.Mutable,
  VantageNames.Columns.Properties,
  VantageNames.Columns.UpdatedAt,
];
